import React from 'react'
import Particle from "../Particle";
import { Container } from "react-bootstrap";
import '../css/education.css'
export default function Education() {
  return (
    <Container fluid className="about-section">
    <Particle />
    <Container>
    <div className="timeline">
  <div className="container1 left1">
    <div className="date">2020-24</div>
    <i className="icon fa fa-home"></i>
    <div className="content">
      <h2>Bachelor of Technology</h2>
      <p>
        <b>NIT Hamirpur  </b><br/>
        <b>Branch:</b> Electronics and Communication Engineering<br/>
        <b>CGPA:</b> 9.23
      </p>
    </div>
  </div>
  <div className="container1 right1">
    <div className="date">2019-20</div>
    <i className="icon fa fa-gift"></i>
    <div className="content">
      <h2>Class 12</h2>
      <p>
      <b>Dalhousie HillTop School, H.P. </b><br/>
        <b>Major:</b> Physics, Chemistry, Mathematics<br/>
        <b>Score:</b> 93.2%
      </p>
    </div>
  </div>
  <div className="container1 left1">
    <div className="date">2017-18</div>
    <i className="icon fa fa-user"></i>
    <div className="content">
      <h2>Class 10</h2>
      <p>
      <b>Dalhousie Public School, H.P. </b><br/>
        <b>Major:</b> Science, Mathematics, English<br/>
        <b>Score:</b> 93%
      </p>
    </div>
  </div> 
</div>
    </Container>
    </Container>
    
  )
}
